import { render, staticRenderFns } from "./payForm.vue?vue&type=template&id=64e6e41e"
import script from "./payForm.vue?vue&type=script&lang=js"
export * from "./payForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports